/** Foundation · Durate — formato attivo corrente (impostato da DurationFormatProvider). */
import { DEFAULT_DURATION_FORMAT, normalizeDurationFormat } from "./durationCore";

let activeFormat = DEFAULT_DURATION_FORMAT;
export const getActiveDurationFormat = () => activeFormat;
export const setActiveDurationFormat = (fmt) => { activeFormat = normalizeDurationFormat(fmt); };
